import React from "react";

type LogoVariant = "lockup" | "mark";

export function Logo({ className = "", variant = "lockup" }: { className?: string; variant?: LogoVariant }) {
  const isMark = variant === "mark";

  return (
    <span
      className={`inline-flex items-center select-none ${isMark ? "gap-2.5" : ""} ${className}`}
    >
      <img
        src={isMark ? "/images/logo.png" : "/images/logo-lockup.png"}
        alt={isMark ? "APA Automotive tire and gear logo" : "APA Automotive"}
        className="h-12 w-auto shrink-0 drop-shadow-[0_12px_26px_rgba(0,0,0,0.35)] sm:h-14"
        width={isMark ? 2880 : 1536}
        height={isMark ? 1482 : 1024}
        decoding="async"
      />
      {isMark ? (
        <span className="whitespace-nowrap text-[0.78rem] font-semibold tracking-[0.18em] text-white/92 sm:text-[0.82rem]">
          APA Automotive
        </span>
      ) : null}
    </span>
  );
}

export default Logo;
